export type HostEnvironment = 'local' | 'staging'

export const hostEnvironment = (hostname: string = window.location.hostname): HostEnvironment | null => {
  if (hostname.includes('localhost')) return 'local'
  if (hostname.includes('staging')) return 'staging'
  return null
}

export const withEnvironmentPrefix = (title: string, hostname?: string): string => {
  const environment = hostEnvironment(hostname)
  return environment ? `[${environment.toUpperCase()}] ${title}` : title
}
